/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { CommonModule } from "@angular/common";
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { SkeletonModule } from "primeng/skeleton";
import { PopoverModule } from "primeng/popover";
import { TooltipModule } from "primeng/tooltip";
import { ToastModule } from "primeng/toast";
import { firstValueFrom, Subject, takeUntil } from "rxjs";
import {
  QPilotCustomer,
  QPilotPaymentMethod,
  QPilotShippingAddress,
} from "../../../../core/models/qpilot";
import { ScheduledOrderCoupon } from "../../../../core/models/scheduled-order-coupon.interface";
import { ScheduledOrder } from "../../../../core/models/scheduled-order.interface";
import { Site } from "../../../../core/models/site.interface";
import {
  QPilotService,
  QPilotAccessToken,
  QPilotUser,
} from "../../../../core/services/qpilot.service";
import { SessionService } from "../../../../core/services/session.service";
import { ScheduledOrderFormComponent } from "../../components/shared/scheduled-order-form/scheduled-order-form.component";
import { TotalsDisplayComponent } from "../../components/shared/totals-display/totals-display.component";
import {
  ScheduledOrderForm,
  ScheduledOrderItemForm,
} from "../../interfaces/scheduled-order-form.interface";
import { ScheduledOrderService } from "../../services/scheduled-order.service";

/**
 * Page component for creating new scheduled orders
 * Initializes a new order with defaults and handles the creation workflow
 */
@Component({
  selector: "app-create-scheduled-order",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    ProgressSpinnerModule,
    CardModule,
    SkeletonModule,
    PopoverModule,
    TooltipModule,
    ToastModule,
    ScheduledOrderFormComponent,
    TotalsDisplayComponent,
  ],
  // Note: MessageService is NOT provided locally - we use the root instance
  // This ensures both component toast calls AND API interceptor error toasts
  // go to the same MessageService that the <p-toast> listens to
  templateUrl: "./create-scheduled-order.component.html",
  styleUrl: "./create-scheduled-order.component.scss",
})
export class CreateScheduledOrderComponent implements OnInit, OnDestroy {
  // Dual mode inputs for web component/iframe support
  @Input() inputSiteId?: number;
  @Input() inputToken?: QPilotAccessToken;
  @Input() inputCustomerId?: number; // Optional: pre-select customer
  @Input() embeddedMode: boolean = false;
  @Input() hideToolbar: boolean = false;

  // Subject for cleanup on destroy
  private readonly destroy$ = new Subject<void>();

  siteId!: number;
  site?: Site;
  scheduledOrder!: Partial<ScheduledOrder>; // The order being created (matches old QMC line 46)
  formGroup!: FormGroup<ScheduledOrderForm>;
  isLoading = false;
  isSaving = false;

  // Subscription tier restrictions
  advancedOptionsAllowed = true; // Default to true, will be set based on tier
  currentTierName = "";
  upgradeUrl = "";

  // Track selected shipping tab for address logic (matches old QMC line 56)
  selectedCustomerShippingTabIndex = 0;

  // New payment method for creation (matches old QMC line 52)
  newPaymentMethod: QPilotPaymentMethod = {} as QPilotPaymentMethod;

  // ViewChild to access form component's shippingRateOptions
  @ViewChild(ScheduledOrderFormComponent)
  formComponent!: ScheduledOrderFormComponent;

  constructor(
    private readonly elementRef: ElementRef, // Required for attribute access in web component mode
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private scheduledOrderService: ScheduledOrderService,
    private qpilotService: QPilotService,
    private sessionService: SessionService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    const element = this.elementRef.nativeElement as HTMLElement;

    // Handle dual mode initialization
    if (this.embeddedMode) {
      // Embedded mode: Get siteId from input/attribute
      const siteIdString =
        this.inputSiteId?.toString() ??
        element.getAttribute("input-site-id") ??
        element.getAttribute("inputSiteId");

      if (siteIdString) {
        this.siteId = parseInt(siteIdString, 10);
      }

      // Get token from attribute and convert to QPilotAccessToken
      const tokenString =
        element.getAttribute("input-token") ??
        element.getAttribute("inputToken");

      // Create inputToken from attribute if:
      // 1. We have a token string from attribute
      // 2. AND inputToken is either missing, not an object, or doesn't have valid TokenBearerAuth
      // Note: Angular Elements may bind the attribute as a raw string, so we check for proper structure
      if (
        tokenString &&
        (!this.inputToken ||
          typeof this.inputToken !== "object" ||
          !this.inputToken.TokenBearerAuth)
      ) {
        this.inputToken = {
          TokenBearerAuth: tokenString,
          TokenAuth: "",
          Id: 0,
          UserId: 0,
          CreatedUtc: new Date(),
          UpdatedUtc: new Date(),
          ExpiresUtc: new Date(),
          User: {} as QPilotUser,
          FirstLogin: 0,
        };
      }

      // Get optional customer ID for pre-selection
      const customerIdString =
        this.inputCustomerId?.toString() ??
        element.getAttribute("input-customer-id") ??
        element.getAttribute("inputCustomerId");

      if (customerIdString) {
        this.inputCustomerId = parseInt(customerIdString, 10);
      }

      // Initialize for embedded mode
      this.initializeFormGroup();
      void this.loadInitialDataEmbedded();
    } else {
      // Standard mode: Extract siteId from route params
      // Route pattern: /widgets/dashboard/:siteId/scheduled-orders/new
      this.route.parent?.params
        .pipe(takeUntil(this.destroy$))
        .subscribe((params) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          this.siteId = +params["siteId"];
          this.initializeFormGroup();
          void this.loadInitialData();
        });
    }
  }

  /**
   * Initialize the reactive form with default values
   * Matches customer portal settings pattern
   */
  private initializeFormGroup(): void {
    // Calculate default next occurrence (30 days from now)
    const defaultNextOccurrence = new Date();
    defaultNextOccurrence.setDate(defaultNextOccurrence.getDate() + 30);

    // Initialize scheduledOrder with defaults (matches old QMC constructor lines 87-94)
    this.scheduledOrder = {
      FrequencyType: "Months",
      Frequency: 1,
      ScheduledOrderItems: [],
      CouponsHistory: [],
      PaymentMethodId: undefined,
      PaymentMethod: undefined,
      CurrencyIso: "USD",
      Status: "Paused",
      Cycles: 0,
      NextOccurrenceUtc: defaultNextOccurrence,
    };

    this.formGroup = this.formBuilder.nonNullable.group({
      // Customer
      customerId: [null as number | null],
      customer: [null as QPilotCustomer | null],

      // Products
      scheduledOrderItems: this.formBuilder.nonNullable.array<
        FormGroup<ScheduledOrderItemForm>
      >([]),

      // Coupons
      coupons: [""],
      couponsHistory: [[] as ScheduledOrderCoupon[]],

      // Frequency
      frequencyType: ["Months"],
      frequency: [1, [Validators.min(1)]],
      cycles: [0], // 0 = infinite
      nextOccurrenceUtc: [
        defaultNextOccurrence as Date | null,
        [Validators.required],
      ],

      // Shipping Address
      shippingFirstName: [""],
      shippingLastName: [""],
      shippingStreet1: [""],
      shippingStreet2: [""],
      shippingCity: [""],
      shippingState: [""],
      shippingPostcode: [""],
      shippingCountry: [""],
      preferredShippingRateOption: [null as string | null],
      enableAutoShippingRate: [false],
      siteShippingAddressId: [null as number | null],
      siteShippingAddress: [null as QPilotShippingAddress | null],

      // Payment
      paymentMethodId: [null as number | null],
      paymentMethod: [null as QPilotPaymentMethod | null],

      // Advanced Options
      name: [""],
      note: [""],
      nextOccurrenceOffset: [0],
      nextOccurrenceTime: [null as string | null],
      customerTimezone: [null as number | null],

      // Settings
      currencyIso: ["USD"],
      utcOffset: [0],
      status: ["Paused"],
      displaySalePrice: [false],
    });

    // Subscribe to form changes for validation
    this.formGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      // Form validation happens automatically
      // Save button state is managed by form component
    });
  }

  /**
   * Get access token based on mode (embedded vs standard)
   */
  getAccessToken(): QPilotAccessToken | undefined {
    if (this.embeddedMode && this.inputToken) {
      return this.inputToken;
    }
    // Use null coalescing to convert null to undefined for type consistency
    return this.sessionService.accessToken ?? undefined;
  }

  /**
   * Load site data for embedded mode with provided token
   */
  private async loadInitialDataEmbedded(): Promise<void> {
    this.isLoading = true;

    try {
      const accessToken = this.getAccessToken();

      if (!accessToken) {
        console.error("No access token available for embedded mode");
        this.messageService.add({
          severity: "error",
          summary: "Authentication Error",
          detail: "Unable to load site data. Invalid token.",
        });
        return;
      }

      // Load site, settings, and subscription tier permissions
      const [siteFull, settings] = await Promise.all([
        firstValueFrom(
          this.qpilotService.getSiteFull(this.siteId, accessToken),
        ),
        firstValueFrom(
          this.qpilotService.getSiteSettings(this.siteId, accessToken),
        ),
      ]);

      // Convert SiteFull to Site interface (they're compatible)
      this.site = siteFull as unknown as Site;

      // Populate form with site-specific defaults
      this.formGroup.patchValue({
        currencyIso: settings.CurrencyIso || "USD",
        utcOffset: this.site.UtcOffset || 0,
      });

      // Load tier permissions (non-blocking)
      void this.loadSubscriptionTierPermissions();

      // Note: inputCustomerId can be stored for use by form component
      // but automatic pre-selection is not implemented yet
      // The customer selector in the form will need to handle this
    } catch (error) {
      console.error("Error loading site data in embedded mode:", error);
      this.messageService.add({
        severity: "error",
        summary: "Load Failed",
        detail: "Failed to load site information. Please try again.",
      });
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * Load site data and populate form with site-specific defaults
   */
  private async loadInitialData(): Promise<void> {
    this.isLoading = true;

    try {
      const accessToken = this.getAccessToken();

      if (!accessToken) {
        this.messageService.add({
          severity: "error",
          summary: "Authentication Error",
          detail: "Unable to load site data. Please sign in again.",
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.router.navigate(["/auth/login"]);
        return;
      }

      // Load site, settings, and subscription tier permissions
      const [siteFull, settings] = await Promise.all([
        firstValueFrom(
          this.qpilotService.getSiteFull(this.siteId, accessToken),
        ),
        firstValueFrom(
          this.qpilotService.getSiteSettings(this.siteId, accessToken),
        ),
      ]);

      // Convert SiteFull to Site interface (they're compatible)
      this.site = siteFull as unknown as Site;

      // Populate form with site-specific defaults
      this.formGroup.patchValue({
        currencyIso: settings.CurrencyIso || "USD",
        utcOffset: this.site.UtcOffset || 0,
      });

      // Load tier permissions (non-blocking)
      this.loadSubscriptionTierPermissions();
    } catch (error) {
      console.error("Error loading site data:", error);
      this.messageService.add({
        severity: "error",
        summary: "Load Failed",
        detail: "Failed to load site information. Please try again.",
      });
      // Navigate back to list (standard mode only - embedded mode shouldn't auto-navigate on error)
      if (!this.embeddedMode) {
        void this.router.navigate([
          "/widgets",
          "dashboard",
          this.siteId,
          "scheduled-orders",
        ]);
      }
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * Load subscription tier permissions to determine if advanced options are allowed
   */
  private async loadSubscriptionTierPermissions(): Promise<void> {
    try {
      // Get page URL from router to check permissions
      // For scheduled orders create page, the URL path is "scheduled-orders"
      const pageUrl = "scheduled-orders";

      // Get the access token (supports embedded mode)
      const accessTokenObj = this.getAccessToken();
      if (!accessTokenObj) {
        console.warn("No access token object available for tier permissions");
        return;
      }

      // Fetch both page permissions and site tier in parallel
      const [pagePermissions, siteTier] = await Promise.all([
        firstValueFrom(
          this.qpilotService.getPageByUrl(
            pageUrl,
            this.siteId.toString(),
            accessTokenObj,
          ),
        ),
        firstValueFrom(
          this.qpilotService.fetchSiteSubscriptionTier(
            accessTokenObj,
            this.siteId.toString(),
          ),
        ),
      ]);

      // Set permissions based on subscription tier
      this.advancedOptionsAllowed = pagePermissions.allowedForSubscription;
      this.currentTierName = siteTier.TierName
        ? `${siteTier.TierName} Plan`
        : "Current Plan";
      this.upgradeUrl = "/my-account/subscription/change-plan";

      console.log(
        "Subscription tier permissions loaded:",
        this.advancedOptionsAllowed,
        this.currentTierName,
      );
    } catch (error) {
      console.error("Error loading subscription tier permissions:", error);
      // Default to allowed if there's an error (graceful degradation)
      this.advancedOptionsAllowed = true;
    }
  }

  /**
   * Apply form values to scheduledOrder object
   * Updates scheduledOrder directly from form (matches old QMC pattern of direct property modification)
   */
  private applyFormValuesToOrder(): void {
    const formValues = this.formGroup.value;

    // Apply all form values to scheduledOrder
    this.scheduledOrder.CustomerId = formValues.customerId!;
    this.scheduledOrder.Customer = formValues.customer!;
    this.scheduledOrder.FrequencyType = formValues.frequencyType!;
    this.scheduledOrder.Frequency = formValues.frequency!;
    this.scheduledOrder.Cycles = formValues.cycles!;
    this.scheduledOrder.NextOccurrenceUtc = formValues.nextOccurrenceUtc as any;
    this.scheduledOrder.Status = formValues.status!;

    // Map form items to API items (matches old QMC - ensures Price and SalePrice are included)
    this.scheduledOrder.ScheduledOrderItems = (
      formValues.scheduledOrderItems || []
    ).map((formItem: any) => ({
      Id: formItem.id ?? 0, // 0 for new items (API will assign real ID on create)
      ProductId: formItem.productId,
      ProductName: formItem.product?.Title || "",
      Product: formItem.product,
      Quantity: formItem.quantity,
      Price: formItem.price, // API requires Price field
      SalePrice: formItem.salePrice, // API requires SalePrice field
      Total: 0, // Will be calculated by API
      Cycles: formItem.cycles, // Number of cycles to include item (undefined if not set)
      MinCycles: formItem.minCycles, // Minimum cycles before item can be included (undefined if not set)
      MaxCycles: formItem.maxCycles, // Maximum cycles item can be included (undefined if not set)
      Disabled: formItem.disabled ?? false, // Include disabled state
    }));
    this.scheduledOrder.Coupons = formValues.coupons || "";
    this.scheduledOrder.CouponsHistory = formValues.couponsHistory || [];
    this.scheduledOrder.ShippingFirstName = formValues.shippingFirstName!;
    this.scheduledOrder.ShippingLastName = formValues.shippingLastName!;
    this.scheduledOrder.ShippingStreet1 = formValues.shippingStreet1!;
    this.scheduledOrder.ShippingStreet2 = formValues.shippingStreet2!;
    this.scheduledOrder.ShippingCity = formValues.shippingCity!;
    this.scheduledOrder.ShippingState = formValues.shippingState!;
    this.scheduledOrder.ShippingPostcode = formValues.shippingPostcode!;
    this.scheduledOrder.ShippingCountry = formValues.shippingCountry!;
    this.scheduledOrder.PreferredShippingRateOption =
      formValues.preferredShippingRateOption || undefined;
    this.scheduledOrder.EnableAutoShippingRate =
      formValues.enableAutoShippingRate!;
    this.scheduledOrder.PaymentMethodId =
      formValues.paymentMethodId || undefined;
    this.scheduledOrder.PaymentMethod = formValues.paymentMethod || undefined;
    this.scheduledOrder.Name = formValues.name!;
    this.scheduledOrder.Note = formValues.note!;
    this.scheduledOrder.NextOccurrenceOffset = formValues.nextOccurrenceOffset!;
    this.scheduledOrder.CurrencyIso = formValues.currencyIso!;
    this.scheduledOrder.UtcOffset = formValues.utcOffset!;
    this.scheduledOrder.DisplaySalePrice = formValues.displaySalePrice!;

    // CRITICAL: Get ShippingRateOptions from form component (not in reactive form, stored as component state)
    if (this.formComponent) {
      this.scheduledOrder.ShippingRateOptions =
        this.formComponent.shippingRateOptions || [];
    }
  }

  /**
   * Create the scheduled order
   * Simplified to match old QMC create() method (lines 248-280)
   * Applies form values directly to scheduledOrder, then calls API
   */
  async create(): Promise<void> {
    // Minimal validation (matches old QMC - just check customer and items)
    const formValues = this.formGroup.value;
    if (
      !formValues.customerId ||
      !formValues.scheduledOrderItems ||
      formValues.scheduledOrderItems.length === 0
    ) {
      this.messageService.add({
        severity: "warn",
        summary: "Validation Error",
        detail: "Customer and at least one product are required",
        life: 5000,
      });
      return;
    }

    // Validate next occurrence date is not empty
    if (!formValues.nextOccurrenceUtc) {
      this.messageService.add({
        severity: "warn",
        summary: "Validation Error",
        detail: "Next Occurrence Date is required",
        life: 5000,
      });
      return;
    }

    this.isSaving = true;

    try {
      // Step 1: Apply form values to scheduledOrder
      this.applyFormValuesToOrder();

      // Step 2: Apply timezone conversion for NextOccurrenceUtc (matches old QMC lines 249-257)
      if (this.site && this.scheduledOrder.NextOccurrenceUtc) {
        const nextOccurrenceDate = new Date(
          this.scheduledOrder.NextOccurrenceUtc,
        );

        if (this.site.SupportsProcessingWindow) {
          // For V3 sites with processing window, extract time and convert
          const hours = nextOccurrenceDate
            .getHours()
            .toString()
            .padStart(2, "0");
          const minutes = nextOccurrenceDate
            .getMinutes()
            .toString()
            .padStart(2, "0");
          const timeString = `${hours}:${minutes}`;

          // Note: DateHelper methods would be used here, but we don't have them yet
          // For now, keep the date as-is (Phase 6 will add timezone helpers)
          this.scheduledOrder.NextOccurrenceUtc =
            nextOccurrenceDate.toISOString();
        } else {
          // For non-V3 sites, use simple offset conversion
          this.scheduledOrder.NextOccurrenceUtc =
            nextOccurrenceDate.toISOString();
        }
      }

      // Step 3: Set payment method from newPaymentMethod if no payment method selected (matches old QMC lines 259-261)
      if (
        this.scheduledOrder.PaymentMethodId == null &&
        this.newPaymentMethod.Type != null
      ) {
        this.scheduledOrder.PaymentMethod = this.newPaymentMethod;
      }

      // Step 4: Clear SiteShippingAddressId if using custom address (matches old QMC lines 263-265)
      if (this.selectedCustomerShippingTabIndex === 0) {
        this.scheduledOrder.SiteShippingAddressId = undefined;
      }

      // Step 5: Call API directly (matches old QMC line 268)
      const created = await firstValueFrom(
        this.scheduledOrderService.create(
          this.siteId,
          this.scheduledOrder as ScheduledOrder,
          this.getAccessToken(),
        ),
      );

      // Step 6: Check for rejected coupons after creation (matches old QMC line 271)
      const rejectedCouponsMessage = this.getCouponsValidationError(created);

      // Show success message
      this.messageService.add({
        severity: "success",
        summary: "Success",
        detail: `Scheduled order #${created.Id} created successfully`,
        life: 3000,
      });

      // Show warning if any coupons were rejected
      if (rejectedCouponsMessage) {
        this.messageService.add({
          severity: "warn",
          summary: "Coupons Not Applied",
          detail: rejectedCouponsMessage,
          life: 8000,
        });
      }

      // Navigate back to list (handles both embedded and standard modes)
      this.navigateToList(created.Id);
    } catch (error) {
      console.error("Error creating scheduled order:", error);
      const errorMessage =
        (error as any)?.message || "Failed to create scheduled order";
      this.messageService.add({
        severity: "error",
        summary: "Creation Failed",
        detail: errorMessage,
        life: 5000,
      });
    } finally {
      this.isSaving = false;
    }
  }

  /**
   * Compare submitted coupons vs accepted coupons after order creation
   * Shows warning message if any coupons were silently rejected by the API
   * Matches old QMC lines 282-304
   * @param createdOrder The order returned from API after creation
   * @returns Error message if coupons were rejected, null otherwise
   */
  private getCouponsValidationError(
    createdOrder: ScheduledOrder,
  ): string | null {
    // Get the coupon codes that the API actually accepted (remove whitespace)
    const scheduledOrderCoupons = createdOrder.Coupons
      ? createdOrder.Coupons.replace(/\s/g, "")
      : "";

    if (this.scheduledOrder.Coupons) {
      let invalidCoupons: string;
      if (scheduledOrderCoupons) {
        // Compare input coupons vs accepted coupons (matches old QMC lines 288-293)
        const couponCodesThatWhereInput =
          this.scheduledOrder.Coupons.split(",");
        const couponCodesThatWhereAccepted = scheduledOrderCoupons.split(",");
        const couponCodesThatWhereNotAccepted =
          couponCodesThatWhereInput.filter(
            (item) => couponCodesThatWhereAccepted.indexOf(item) === -1,
          );
        invalidCoupons = couponCodesThatWhereNotAccepted.join(",");
      } else {
        // All coupons were rejected (matches old QMC line 295)
        invalidCoupons = this.scheduledOrder.Coupons;
      }

      if (invalidCoupons) {
        // Return error message (matches old QMC line 299)
        return `The following coupons could not be applied to the scheduled order (non existent or invalid): ${invalidCoupons}`;
      }

      return null;
    }

    return null;
  }

  /**
   * Navigate back to list with dual mode support
   * Emits custom event in embedded mode, uses Angular Router in standard mode
   */
  private navigateToList(orderId?: number): void {
    if (this.embeddedMode) {
      // Emit event to signal completion
      const event = new CustomEvent("qmc-order-saved", {
        detail: {
          component: "scheduled-order",
          action: "list",
          orderId: orderId,
          siteId: this.siteId,
        },
        bubbles: true,
        composed: true, // Crosses shadow DOM boundary
      });
      this.elementRef.nativeElement.dispatchEvent(event);
    } else {
      // Use standard routing
      void this.router.navigate([
        "/widgets",
        "dashboard",
        this.siteId,
        "scheduled-orders",
      ]);
    }
  }

  /**
   * Cancel and navigate back to list
   */
  cancel(): void {
    this.navigateToList();
  }

  // Note: canSubmit validation is now handled by the form component
  // It checks actual form values (customer and products)

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
